/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_Assetinfo_Msi1Inputs */

const id_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wizard instalasi standar. Direkomendasikan untuk sebagian besar pengguna.`)
};

const ms_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wizard pemasangan standard. Disyorkan untuk kebanyakan pengguna.`)
};

const da_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En standard installationsguide. Anbefalet til de fleste brugere.`)
};

const de_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein standardmäßiger Installationsassistent. Für die meisten Benutzer empfohlen.`)
};

const en_us2_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A standard installer wizard. Recommended for most users.`)
};

const es_es2_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un asistente de instalación estándar. Recomendado para la mayoría de los usuarios.`)
};

const es_mx2_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un asistente de instalación estándar. Recomendado para la mayoría de los usuarios.`)
};

const fil_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isang standard na installer wizard. Inirerekomenda para sa karamihan ng mga user.`)
};

const fr_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un assistant d'installation standard. Recommandé pour la plupart des utilisateurs.`)
};

const it_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un'installazione guidata standard. Consigliata per la maggior parte degli utenti.`)
};

const hu_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szabványos telepítővarázsló. A legtöbb felhasználónak ajánlott.`)
};

const nl_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een standaard installatiewizard. Aanbevolen voor de meeste gebruikers.`)
};

const no_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En standard installasjonsveiviser. Anbefalt for de fleste brukere.`)
};

const pl_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardowy kreator instalacji. Zalecane dla większości użytkowników.`)
};

const pt_br2_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um assistente de instalação padrão. Recomendado para a maioria dos usuários.`)
};

const pt_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um assistente de instalação padrão. Recomendado para a maioria dos utilizadores.`)
};

const ro_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un asistent de instalare standard. Recomandat pentru majoritatea utilizatorilor.`)
};

const fi_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vakioasennusvelho. Suositeltu useimmille käyttäjille.`)
};

const sv_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En standardinstallationsguide. Rekommenderas för de flesta användare.`)
};

const vi_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trình hướng dẫn cài đặt tiêu chuẩn. Được đề xuất cho hầu hết người dùng.`)
};

const tr_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standart bir kurulum sihirbazı. Çoğu kullanıcı için önerilir.`)
};

const cs_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardní instalační průvodce. Doporučeno pro většinu uživatelů.`)
};

const bg_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандартен инсталационен съветник. Препоръчва се за повечето потребители.`)
};

const ru_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандартный мастер установки. Рекомендуется для большинства пользователей.`)
};

const uk_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандартний майстер встановлення. Рекомендовано для більшості користувачів.`)
};

const ar_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معالج تثبيت قياسي. موصى به لمعظم المستخدمين.`)
};

const hi_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मानक इंस्टॉलर। अधिकांश उपयोगकर्ताओं के लिए अनुशंसित।`)
};

const th_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตัวช่วยติดตั้งมาตรฐาน แนะนำสำหรับผู้ใช้ส่วนใหญ่`)
};

const ja_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準インストーラーウィザード。ほとんどのユーザーに推奨。`)
};

const zh_cn2_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准安装向导。推荐大多数用户使用。`)
};

const zh_hant1_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準安裝精靈。建議大多數使用者使用。`)
};

const ko_misc_downloads_assetinfo_msi1 = /** @type {(inputs: Misc_Downloads_Assetinfo_Msi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`표준 설치 마법사입니다. 대부분의 사용자에게 권장됩니다.`)
};

/**
* | output |
* | --- |
* | "A standard installer wizard. Recommended for most users." |
*
* @param {Misc_Downloads_Assetinfo_Msi1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_assetinfo_msi1 = /** @type {((inputs?: Misc_Downloads_Assetinfo_Msi1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_Assetinfo_Msi1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "ms") return ms_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "da") return da_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "de") return de_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "fil") return fil_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "fr") return fr_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "it") return it_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "hu") return hu_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "nl") return nl_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "no") return no_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "pl") return pl_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "pt") return pt_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "ro") return ro_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "fi") return fi_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "sv") return sv_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "vi") return vi_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "tr") return tr_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "cs") return cs_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "bg") return bg_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "ru") return ru_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "uk") return uk_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "ar") return ar_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "hi") return hi_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "th") return th_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "ja") return ja_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_assetinfo_msi1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_assetinfo_msi1(inputs)
	return ko_misc_downloads_assetinfo_msi1(inputs)
});
export { misc_downloads_assetinfo_msi1 as "misc.downloads.assetInfo.msi" }